import { useUserProfileStore } from '../../stores/userProfileStore'
import { getInitialsLetters } from '../../utils/text'
import LoadingSection from '../LoadingSection/LoadingSection'

import ChangeEmail from './ChangeEmail/ChangeEmail'
import ChangePassword from './ChangePassword/ChangePassword'
import Username from './Username/Username'

import styles from './account.module.scss'

function Account() {
    const [{ userProfile }] = useUserProfileStore()

    if (!userProfile) {
        return <LoadingSection />
    }

    const { username } = userProfile

    return (
        <main className={styles.account}>
            <header className={styles.account__header}>
                <div className={styles.account__initialsWrapper}>
                    <div className={styles.account__initials}>
                        {getInitialsLetters(username)}
                    </div>
                </div>
                <Username />
            </header>
            <section className={styles.account__section}>
                <ChangeEmail />
                <ChangePassword />
            </section>
        </main>
    )
}

export default Account
